export default __webpack_public_path__ + "static/media/video_camera_2_white.bb039e58.svg";